<template>
  <div class="w-full sm:w-full md:w-2/3 lg:w-1/3 xl:w-2/3 mb-4">
    <vs-card
      id="compliance_table"
      class="vs-con-loading__container px-2 widget-card"
    >
      <card-header :title="$t('widget_compliance_by_status')"></card-header>
      <vs-row class="mt-4">
        <vs-col>
          <div  class="widget-table">
            <table-striped
              :users="permitListTable"
            ></table-striped>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import ComplianceTableDashboard from '@/views/pages/home/tables/ComplianceTableDashboard.vue'
//requests
import dashboard from '@/http/requests/compliance'
//mixins
import loading from '@/mixins/Loading.js'
import CardHeader from './CardHeader.vue'

export default {
  mixins: [loading],
  components: {
    'table-striped': ComplianceTableDashboard,
    CardHeader
  },
  computed: {
    isLoading() {
      return this.loading.compliance_table
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('compliance_table')
      } else {
        this.closeLoading('compliance_table')
      }
    },
  },
  data() {
    return {
      labels: [],
      permitList: [],
      permitListTable: [],
      loading: {
        compliance_table: false,
      },
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading.compliance_table = true
      dashboard
        .complianceTableList()
        .then((res) => {
          this.permitList = res.data.compliance
          this.findLabels(this.permitList)
          this.permitListTable = this.filterByState(
            this.permitList,
            'Not in Compliance'
          )
          if (this.permitListTable.length === 0) {
            this.permitListTable = this.filterByState(
              this.permitList,
              'Soon to Expire'
            )
          }
          if (this.permitListTable.length === 0) {
            this.permitListTable = this.filterByState(
              this.permitList,
              'In Compliance'
            )
          }
          this.loading.compliance_table = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.compliance_table = false
        })
    },
    RenderTable(Status) {
      this.permitListTable = this.filterByState(this.permitList, Status)
    },
    filterByState(data, state) {
      const filteredData = []
      data.forEach((element) => {
        if (element.status_name === state) {
          filteredData[filteredData.length] = element
        }
      })
      return filteredData
    },
    findLabels(data) {
      const labels = []
      data.forEach((element) => {
        if (labels.indexOf(element.status_name) === -1) {
          labels[labels.length] = element.status_name
          this.labels[this.labels.length] = {
            name: element.status_name,
            color:
              element.status_color == null ? '#E8ECE9' : element.status_color,
          }
        }
      })
    },
  },
}
</script>